import { Batch } from './batch'

export interface SearchBatchNoInterface {
  /**
   * 用户姓名
   */
  name: string
  /**
   * 用户随机码列表
   *  - 数据顺序即其生成顺序
   */
  batchNos: string[]
  /**
   * 关联的批次信息
   */
  batch?: Batch
}

export class SearchBatchNo implements SearchBatchNoInterface {
  /**
   * 用户姓名
   */
  name: string
  /**
   * 用户随机码列表
   *  - 数据顺序即其生成顺序
   */
  batchNos: string[]
  /**
   * 关联的批次信息
   */
  batch?: Batch

  constructor(props: SearchBatchNoInterface) {
    const {
      // 重命名变量以规避与 JS 保留词的冲突, 比如 default, with
      name: _name,
      batchNos: _batchNos,
      batch: _batch,
      // 可能会有额外字段比如自定义字段不在类型定义中
      ...rest
    } = props

    Object.assign(this, rest)

    this.name = _name
    this.batchNos = _batchNos
    this.batch = _batch ? new Batch(_batch) : _batch
  }
}
